<template>
    <v-col class="pa-0">
        <v-card class="round-card background-2">
            <v-card-title class="pa-3">
                <p class="pl-2 pl-xl-3">Eventi Calendario</p>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-text-field class="hidden-xs-only font-weight-regular" v-show="expand"
                    append-icon="search"
                    label="Cerca"
                    v-model="search"
                    clearable
                    hide-details
                    outlined
                    dense
                ></v-text-field>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn @click="getEvents()" :loading="loaderButton" v-on="on" icon>
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </template>
                    <span>Refresh</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="expand = !expand" icon>
                            <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
                </v-tooltip>
            </v-card-title>
            <v-divider v-show="expand"></v-divider>
            <v-container class="py-0" fluid v-show="expand">
                <v-row class="ma-0">
                    <v-col cols="12" class="pa-3 hidden-sm-and-up">
                        <v-text-field
                            append-icon="search"
                            label="Cerca"
                            v-model="search"
                            clearable
                            hide-details
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
            <v-expand-transition>
                <v-data-iterator
                    v-show="expand"
                    :items="events"
                    :options.sync="pagination"
                    :server-items-length="totalItems"
                    :footer-props="{
                        'items-per-page-options': [5, 10, 25]
                    }">
                    <template v-slot:no-data>
                        <v-card class="background-2 fs12i py-0 mx-4" elevation="0">
                            <v-card-text class="caption text-center pb-4 pt-6">Nessun evento a calendario</v-card-text>
                        </v-card>
                        <v-divider></v-divider>
                    </template>
                    <template v-slot:item="{ item }">
                        <v-list-item
                            class="px-4"
                            @click="navigateToEvent(item)"
                            :key="item.id">
                            <v-list-item-avatar :size="32" class="mr-3">
                                <v-avatar
                                    :color="item.calendar ? item.calendar.color : 'primary'"
                                    :size="32">
                                    <v-icon small class="white--text">mdi-calendar</v-icon>
                                </v-avatar>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title class="fs13">{{ item.name }}</v-list-item-title>
                                <v-list-item-subtitle class="fs11 capitalize">
                                    {{ formatEventDate(item) }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle v-if="item.calendar" class="fs11 grey--text">
                                    {{ item.calendar.name }}
                                    <span v-if="item.creator"> &middot; {{ item.creator }}</span>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-chip
                                    x-small
                                    :color="getStatusColor(item)"
                                    dark
                                    class="fs10">
                                    {{ getStatusText(item) }}
                                </v-chip>
                            </v-list-item-action>
                        </v-list-item>
                        <v-divider></v-divider>
                    </template>
                    <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
                        Da {{ pageStart }} a {{ pageStop }} di {{ itemsLength }}
                    </template>
                </v-data-iterator>
            </v-expand-transition>
        </v-card>
    </v-col>
</template>

<script>
import CalendarMixin from '@/mixins/CalendarMixin'

export default {
    name: 'entity-calendar-events',
    mixins: [CalendarMixin],
    props: {
        modelClass: String,
        modelId: Number
    },

    data() {
        return {
            events: [],
            allEvents: [],
            pagination: { itemsPerPage: 5 },
            totalItems: 0,
            loaderButton: false,
            expand: true,
            loadTimeout: null,
            search: '',
            debounceUnwatch: {}
        }
    },

    watch: {
        pagination: {
            handler() {
                this.filterEvents()
            },
            deep: true
        }
    },

    computed: {
        getStatusColor() {
            return (item) => {
                const now = moment()
                const start = moment(item.started_at)
                const end = moment(item.ended_at)
                if (now.isBefore(start)) return 'info'
                if (now.isBetween(start, end)) return 'success'
                return 'grey'
            }
        },

        getStatusText() {
            return (item) => {
                const now = moment()
                const start = moment(item.started_at)
                const end = moment(item.ended_at)
                if (now.isBefore(start)) return 'Pianificato'
                if (now.isBetween(start, end)) return 'In corso'
                return 'Passato'
            }
        }
    },

    methods: {
        getEvents() {
            if (this.loadTimeout) clearTimeout(this.loadTimeout)

            this.loadTimeout = setTimeout(() => {
                this.loaderButton = true
                let dataObject = {
                    subFilters: {
                        eventable_id: this.modelId,
                        eventable_type: this.modelClass
                    }
                }

                this.axios.post('/events-filters', dataObject).then(response => {
                    const data = response.data.data || []
                    data.sort((a, b) => moment(b.started_at).diff(moment(a.started_at)))
                    this.allEvents = data
                    this.filterEvents()
                    setTimeout(() => { this.loaderButton = false }, 500)
                }, () => {
                    this.loaderButton = false
                })
            }, 300)
        },

        filterEvents() {
            let filtered = this.allEvents
            if (this.search) {
                const term = this.search.toLowerCase()
                filtered = this.allEvents.filter(e => {
                    const name = (e.name || '').toLowerCase()
                    const description = (e.description || '').toLowerCase()
                    return name.includes(term) || description.includes(term)
                })
            }
            this.totalItems = filtered.length
            const start = ((this.pagination.page || 1) - 1) * this.pagination.itemsPerPage
            const end = start + this.pagination.itemsPerPage
            this.events = filtered.slice(start, end)
        },

        navigateToEvent(event) {
            this.$router.push({
                path: '/calendar',
                query: { event_id: event.id }
            }).catch(() => {})
        }
    },

    mounted() {
        this.debounceUnwatch = this.$watch('search', _.debounce(() => {
            this.pagination.page = 1
            this.filterEvents()
        }, 700))

        if (this.modelClass && this.$store.getters.checkSettings('compact_' + this.modelClass + '_view')) {
            this.expand = false
        } else {
            this.expand = !this.$store.getters.checkSettings('compact_viewing')
        }
        this.getEvents()
    }
}
</script>
